import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { getSubscriptors } from "../../services/SharedServices";
import moment from "moment";

export default function SubscriptorsList() {
  const [loading, setLoading] = useState(false);
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await getSubscriptors({
        token: "",
      });
      setSubs(response.data.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs title="Contactos" breadcrumbItem="Contactos" />

        <Row>
          <Col>
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0">
                <Table className="table table-striped table-bordered">
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Fecha</Th>
                      <Th>Nombre</Th>
                      <Th>Email</Th>
                      <Th>Celular</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {subs.map((item: any) => (
                      <Tr>
                        <Th>{item.id}</Th>
                        <Th>{moment(item.created_at).format("DD/MM/YYYY")}</Th>
                        <Th>{item.name}</Th>
                        <Th>{item.email}</Th>
                        <Th>{item.wpp}</Th>
                        <Th>
                          <a href={item.property_id} target="_blank">
                            {item.property_id}
                          </a>
                        </Th>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
